/**
 * Provide convenient API for application.
 * Use abstract data provider for data retrieving and handle it for application purposes.
 *
 * @module app.api.provider
 *
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

module.exports = function ( config, callback ) {
    var dataProvider = require('./data.provider'),
        api = {
            /**
             * Return a handled list of radio channels for app.
             *
             * @param {Object} queryStringSet - set of name-value GET parameters
             * @param {Function} getRadioChannelsCallback - callback function
             */
            getRadioChannels: function ( queryStringSet, getRadioChannelsCallback ) {
                dataProvider.getRadioChannels(queryStringSet, function ( error, result ) {
                    var radioChannels;

                    if ( error ) {
                        getRadioChannelsCallback({message: 'Bad request error!'});
                    } else {
                        try {
                            if ( Array.isArray(result.data) ) {
                                radioChannels = result.data.map(function ( item ) {
                                    return {
                                        id:       item.id,
                                        date:     item.number,
                                        name:     item.name,
                                        url:      item.url,
                                        solution: item.solution,
                                        favorite: item.favorite
                                    };
                                });

                                getRadioChannelsCallback(null, radioChannels);
                            } else {
                                getRadioChannelsCallback({message: 'Parse result error!'});
                            }
                        } catch ( error ) {
                            getRadioChannelsCallback({message: 'Parse result error!'});
                        }
                    }
                });
            },
            /**
             * Add or delete channel from favorites list.
             *
             * @param {number} channelId - ID of the radio channel
             * @param {boolean} favoriteState - favorites flag
             * @param {Function} setFavoriteStateCallback - callback function
             */
            setRadioChannelFavoriteState: function ( channelId, favoriteState, setFavoriteStateCallback ) {
                dataProvider.setRadioChannelFavoriteState(channelId, JSON.stringify({favorite: favoriteState}), setFavoriteStateCallback);
            }
        };

    callback(null, api);
};
